import { Box, Flex } from "@chakra-ui/react";

import Burger from "./Burger";
import Image from "next/image";
import { Link } from "toolkit/chakra/link";
import React from "react";
import RewardsButton from "ui/rewards/RewardsButton";
import SearchBarMobile from "../searchBar/SearchBarMobile";
import UserProfileMobile from "ui/snippets/user/profile/UserProfileMobile";
import UserWalletMobile from "ui/snippets/user/wallet/UserWalletMobile";
import config from "configs/app";
import { useColorModeValue } from "toolkit/chakra/color-mode";
import { useIsSticky } from "toolkit/hooks/useIsSticky";

type Props = {
  hideSearchButton?: boolean;
  renderSearchBar?: () => React.ReactNode;
};

const HeaderMobile = ({ hideSearchButton }: Props) => {
  const ref = React.useRef<HTMLDivElement>(null);
  const isSticky = useIsSticky(ref, 5);
  const logoSrc = useColorModeValue(
    "/assets/logo-light.png",
    "/assets/logo-dark.png",
  );

  return (
    <Box
      ref={ref}
      bgColor={{ _light: "white", _dark: "black" }}
      display={{ base: "block", lg: "none" }}
      position="sticky"
      top="-1px"
      left={0}
      zIndex="sticky2"
      pt="1px"
      height="56px"
    >
      {/* push test 3  */}
      {/* push test 3  */}
      <Flex
        as="header"
        paddingX={2}
        paddingY={2}
        bgColor={{ _light: "white", _dark: "black" }}
        width="100%"
        alignItems="center"
        justifyContent="space-between"
        transitionProperty="box-shadow"
        transitionDuration="slow"
        boxShadow={isSticky ? "md" : "none"}
      >
        <Flex as="div" columnGap={2} alignItems="center">
          <Burger />
          {/* <NetworkLogo ml={ 2 } mr="auto"/> */}
          <Link
            style={{
              display: "flex",
              alignItems: "center",
            }}
            href="/"
            noIcon
          >
            <Image
              src={logoSrc}
              width={210}
              height={42}
              alt="DotOneScan logo"
              className="doto-logo-navigation"
            />
          </Link>
        </Flex>
        <Flex columnGap={2}>
          {!hideSearchButton && <SearchBarMobile />}
          {config.features.rewards.isEnabled && <RewardsButton />}
          {(config.features.account.isEnabled && <UserProfileMobile />) ||
            (config.features.blockchainInteraction.isEnabled && (
              <UserWalletMobile />
            ))}
        </Flex>
      </Flex>
    </Box>
  );
};

export default React.memo(HeaderMobile);
